import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { toast } from 'react-toastify';
import { useAppContext } from '../Context/AppContext';
import { ACTIONS } from '../Store';
import { BASEURL } from '../Utils'
export const useMain = () => {
    const state = useSelector((state) => state);
    const { user, logout, login } = useAppContext();
    const { loading, form, error, data } = state;
    const dispatch = useDispatch();
    const setFormObj = (form) => { dispatch(ACTIONS.setFormObj(form)) }
    const setForm = (key, value) => { dispatch(ACTIONS.setForm(key, value)) }
    const clearForm = () => {
        const inputs = window.document.getElementsByTagName('input');
        for (let i = 0; i < inputs.length; i++) {

            let field_type = inputs[i].type.toLowerCase();

            switch (field_type) {

                case "text":
                case "password":
                case "textarea":
                case "hidden":

                    inputs[i].value = "";
                    break;

                case "radio":
                case "checkbox":
                    if (inputs[i].checked) {
                        inputs[i].checked = false;
                    }
                    break;

                case "select-one":
                case "select-multi":
                    inputs[i].selectedIndex = -1;
                    break;

                default:
                    break;
            }
        }
        dispatch(ACTIONS.clearForm())
    }
    const setData = (key, value, sub, save) => {
        dispatch(ACTIONS.setData(key, value, sub));
        if (save) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
    const Request = async ({ key = "", loading = "", url, props, progress, cancel_token, sub, callback }) => {
        dispatch(ACTIONS.Request(key || loading));
        let data = { ...form, ...props };

        const axiosInstance = axios.create({
            baseURL: BASEURL,
        })
        if (!progress) {
            progress = () => { }
        }
        const formData = new FormData();
        if (data) {
            for (const [key, value] of Object.entries(data)) {
                if (typeof value === 'object') {
                    for (const [key2, value2] of Object.entries(value)) {

                        formData.append(
                            key + '[]',
                            value2
                        );
                    }
                } else {
                    formData.append(
                        key,
                        value
                    );

                }

            }
        }
        let token = "";
        if (user) {
            token = user.token
        }
        let options = {
            method: "post",
            url: url,
            headers: {
                "Accept": "application/json",
                "authorization": 'Bearer ' + token,
            },
            cancelToken: cancel_token && cancel_token.token,
            onUploadProgress: progress,
            validateStatus: (status) => { return status },
            data: formData
        }
        await axiosInstance(options).then((response) => {
            dispatch(ACTIONS.EndLoad(key || loading))
            if (response.status == '200') {
                if (response.data) {
                    if (callback) {
                        callback(response.data);
                        return;
                    }
                    if (response.data.message) {
                        toast.success(response.data.message);
                    } else {
                        dispatch(ACTIONS.ResponseSuccess(key, response.data, sub))
                    }
                }
            } else {
                if (response.status === 401) {
                    localStorage.clear();
                    logout();
                    return;
                }
           
                if (response.data) {
                    if (response.data.message) {
                        toast.error(response.data.message);
                    } else {
                        toast.error(response.statusText);
                    }
                } else {
                    toast.error(response.statusText);
                }
                if (callback) {
                    callback(false);
                    return;
                }
            }
        }).catch((error) => {
            dispatch(ACTIONS.EndLoad(key))
            toast.error("اتصال برقرار نیست !")
            if (callback) {
                callback(false);
                return;
            }
        })

    }

    return { loading, user, logout, login, form, error, data, setForm, setFormObj, Request, clearForm, setData, state };
}